module.exports = __webpack_public_path__ + "img/bd.d08a5ccc.svg";